import * as Yup from "yup";

export const PasswordProtectedLoginSchema = Yup.object().shape({
  username: Yup.string()
    .trim()
    .required("User name is required")
    .min(2, "User name must be at least 2 characters")
    .max(50, "User name must be less then 50 characters")
    .matches(/^[A-Z a-z]+$/, {
      message: "Please enter a valid user name without numbers",
    }),
  password: Yup.string()
    .trim()
    .required("Password is required")
    .min(5, "User name must be at least 5 characters")
    .max(50, "User name must be less then 50 characters"),
});
